import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { OutsideClick } from '../../../../../shared/directives/outside-click/outside-click.directive';
import type { CourseContentSidebarModuleItem } from '../../../../../shared/models/interfaces/sidebar.interface';

@Component({
  selector: 'l-sidebar-module-selector',
  standalone: true,
  imports: [CommonModule, IconComponent, OutsideClick],
  templateUrl: './sidebar-module-selector.component.html',
})
export class SidebarModuleSelectorComponent {

  @Input()
  public modules: CourseContentSidebarModuleItem[] = [];

  @Input()
  public selectedModuleId: string = '';

  @Input()
  public isOpen: boolean = true;

  @Input()
  public isDropdownOpen: boolean = false;

  @Input()
  public fallbackTitle: string = '';

  @Output()
  public menuToggled: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public dropdownToggled: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  public dropdownClosed: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public moduleSelected: EventEmitter<string> = new EventEmitter<string>();

  public get orderedModules(): CourseContentSidebarModuleItem[] {
    return [...this.modules].sort((first, second) => (first.order ?? 0) - (second.order ?? 0));
  }

  public get selectedModuleIndex(): number {
    if (!this.orderedModules.length) return 0;

    const index = this.orderedModules.findIndex((module) => module.id === this.selectedModuleId);
    return Math.max(index, 0);
  }

  public get selectedModule(): CourseContentSidebarModuleItem | null {
    if (!this.orderedModules.length) return null;

    return this.orderedModules[this.selectedModuleIndex] ?? null;
  }

  public get selectedModuleLabel(): string {
    return `Módulo ${this.selectedModuleIndex + 1}`;
  }

  public get selectedModuleTitle(): string {
    return this.selectedModule?.title ?? this.fallbackTitle;
  }

  public moduleLabel(index: number): string {
    return `Módulo ${index + 1}`;
  }

  public canAccessModule(index: number): boolean {
    return index === 0 || !!this.orderedModules[index - 1]?.isCompleted;
  }

  public onModuleClick(moduleId: string, index: number, event: Event): void {
    event.stopPropagation();

    if (this.canAccessModule(index) && moduleId !== this.selectedModuleId) {
      this.moduleSelected.emit(moduleId);
    }
  }
}
